import { useEffect, useState } from "react";
import { IMinerChangerLogProps } from "./MinerChangerLog.props";
import { useMinerLogs } from "@utils/hooks/useMinerLogs";
import { IMinerLog } from "@store/minerChangeLogs/actionsTypes";
import { useDispatch } from "react-redux";
import { clearMinerChangeLogs } from "@store/minerChangeLogs/actions";

interface IMinerChangerLogControl {
  readonly open: boolean;
  readonly logs: IMinerLog[];

  onToggleDrawer(): void;
  onClose(): void;
}

export const useMinerChangerLogControl = (
  props: IMinerChangerLogProps
): IMinerChangerLogControl => {
  const dispatch = useDispatch();
  const logs = useMinerLogs();
  const [open, setOpen] = useState(false);

  const onToggleDrawer = () => setOpen((prev) => !prev);

  // useEffect(() => {
  //   if (logs.length) setOpen(true);
  // }, [logs]);

  const onClose = () => {
    setOpen(false);
    dispatch(clearMinerChangeLogs());
  };

  return {
    open,
    logs,

    onToggleDrawer,
    onClose,
  };
};
